"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logReporter = void 0;
const logger_1 = require("../logger");
const types_1 = require("../types");
function logReporter(info, config) {
    const reporter = {
        ...config,
        trackEvent(event) {
            var _a, _b, _c, _d, _e;
            // config.trackEventLevel and config.level overrides event.level here, as it is an override, while config.trackEventDefaultLevel is a fallback.
            const level = (_b = (_a = event.level) !== null && _a !== void 0 ? _a : config.trackEventDefaultLevel) !== null && _b !== void 0 ? _b : types_1.LogLevel.Info;
            logger_1.logger.log(level, event.message, {
                ...((_c = event.metadata) !== null && _c !== void 0 ? _c : {}),
                ...((_d = event.metrics) !== null && _d !== void 0 ? _d : {}),
                ...((_e = event.tags) !== null && _e !== void 0 ? _e : {}),
            });
        },
        addBreadcrumb(breadcrumb) {
            var _a, _b;
            const level = (_a = config.addBreadcrumbLevel) !== null && _a !== void 0 ? _a : types_1.LogLevel.Info;
            logger_1.logger.log(level, breadcrumb.message, {
                ...((_b = breadcrumb.metadata) !== null && _b !== void 0 ? _b : {}),
                category: breadcrumb.category,
            });
        },
        addMetadata(metadata) {
            Object.assign(logger_1.globalMetadata, metadata);
        },
        setUser(user) {
            Object.assign(logger_1.globalMetadata, { user });
        },
        setRouteName(routeName) {
            var _a;
            Object.assign(logger_1.globalMetadata, { routeName });
            const level = (_a = config.setRouteNameLevel) !== null && _a !== void 0 ? _a : types_1.LogLevel.Debug;
            logger_1.logger.log(level, `Route changed to ${routeName}`);
        },
        setPageName(pageName) {
            var _a;
            Object.assign(logger_1.globalMetadata, { pageName });
            const level = (_a = config.setPageNameLevel) !== null && _a !== void 0 ? _a : types_1.LogLevel.Debug;
            logger_1.logger.log(level, `Page changed to ${pageName}`);
        },
        reportError(error, metadata) {
            logger_1.logger.error(typeof error === 'string' ? error : error.message, { ...metadata, error });
        },
        recordSession() {
            var _a;
            const level = (_a = config.recordSessionLevel) !== null && _a !== void 0 ? _a : types_1.LogLevel.Debug;
            logger_1.logger.log(level, 'Recording Session');
        },
        recordSessionStop() {
            var _a;
            const level = (_a = config.recordSessionStopLevel) !== null && _a !== void 0 ? _a : types_1.LogLevel.Debug;
            logger_1.logger.log(level, 'Recording Session Stopping');
        },
    };
    return reporter;
}
exports.logReporter = logReporter;
//# sourceMappingURL=logReporter.js.map